"use strict";
/**
 * @author Maxim Seredkin
 */
export default function () {
  return {
    restrict: "A",
    template: require("../view/org-table-row.html"),
    transclude: true,
    scope: {
      org: "=myValue",
      mySize: "=?mySize",
      myFilters: "=?myFilters",
      myRequired: "=?myRequired",
      myName: "=?myName",
      tooltipText: "=?tooltipText",
      showToolTip: "=?showToolTip",
      edit: "=edit",
    },
    controller: [
      "$scope",
      "OrgService",
      function ($scope, OrgService) {
        $scope.select = select;
        $scope.clear = clear;
        $scope.toggleTooltip = toggleTooltip;

        // region Function

        function select() {
          OrgService.select($scope.org, $scope.myFilters).result.then(
            (data) => ($scope.org = data)
          );
        }

        function clear() {
          $scope.org = null;
        }

        function toggleTooltip() {
          $scope.showToolTip = !$scope.showToolTip;
        }

        // endregion
      },
    ],
  };
}
